import Analytics from '@/utils/analytics';
import React from 'react';
import { APP_MODAL_ROUTES, LOCATION_MANAGER_ROUTES } from '@/navigators/routes';
import { AppModalStackParams } from '@/navigators/types';
import { Platform, StyleProp, View, ViewStyle } from 'react-native';
import { SelectorButton } from './selector-button';
import { StackNavigationProp } from '@react-navigation/stack';
import { useChatsContext } from '@/contexts/chats-context';
import { useNavigation } from '@react-navigation/native';
import { useNavigationConfirmationContext } from '@/contexts/navigation-confirmation-context';
import { useOfflineModeEnabled } from '@/hooks/use-offline-mode-enabled';
import { useOrderInbounds } from '@/hooks/use-order-inbounds';
import { usePaymentsContext } from '@/contexts/payments-context';
import { useSalesRepMode } from '@/hooks/use-sales-rep-mode';
import { useUserContext } from '@/contexts/user-context';

type Navigation = StackNavigationProp<
  AppModalStackParams,
  APP_MODAL_ROUTES.LocationManager
>;

interface Props {
  onPress?: () => void;
  style?: StyleProp<ViewStyle>;
  viewRef?: React.RefObject<View | null>;
}

export const RestaurantSelectorButton: React.FC<Props> = ({
  onPress,
  style,
  viewRef,
}) => {
  const { chatUnreadCountMap } = useChatsContext();
  const { restaurantRelationships, selectedRestaurantRelationship } =
    useUserContext();
  const { navigate } = useNavigation<Navigation>();
  const { isOrderInboundsEnabled } = useOrderInbounds();
  const { restaurantsWithNewInvoices } = usePaymentsContext();
  const { navigationBlocked } = useNavigationConfirmationContext();
  const isOfflineModeEnabled = useOfflineModeEnabled();
  const salesRepMode = useSalesRepMode();

  const isMobile = Platform.OS === 'ios' || Platform.OS === 'android';
  const hasNoActionButtons =
    restaurantRelationships.length === 1 &&
    !isOfflineModeEnabled &&
    !isOrderInboundsEnabled &&
    !isMobile;
  const switchingDisabled = navigationBlocked || hasNoActionButtons;

  return (
    <SelectorButton
      buttonTheme={salesRepMode ? 'light' : 'dark'}
      disabled={switchingDisabled}
      onPress={() => {
        Analytics.track('header_restaurant_selector.restaurant_button.press');
        if (typeof onPress === 'function') {
          onPress();
        } else {
          navigate(APP_MODAL_ROUTES.LocationManager, {
            params: { chatUnreadCountMap, restaurantsWithNewInvoices },
            screen: LOCATION_MANAGER_ROUTES.Base,
          });
        }
      }}
      style={style}
      testId="restaurant-selector-button"
      title={selectedRestaurantRelationship.name}
      viewRef={viewRef}
    />
  );
};
